import { environment as env } from '../../environments/environment';
/* This file should contain All EndPoint Routes Across all the application*/
/* Follow the Naming Convention*/

const server = env.serverUrl;
const contextURI = env.contextURI;
const uri = server + contextURI;
// const BaseUrl = environment.api + environment.apiLang + environment.apiVersion;
export const API_URLS = {
  auth: {
    auth: uri + '/auth/login',
    changePassword: uri + '/auth/changePassword',
    resetPassword: uri + '/auth/resetPassword',
  },
  search: {
    search: uri + '/Search',
  },

  User: {
    post: uri + '/User',
    postArr: uri + '/User/arr',
    get: uri + '/User/all',
    getOne: uri + '/User/{entityId}',
    put: uri + '/User/{entityId}',
    putArr: uri + '/User/arr',
    delete: uri + '/User/{entityId}',

  }, 
  Banner: {
    post: uri + '/Banner',
    postArr: uri + '/Banner/arr',
    get: uri + '/Banner/all',
    getOne: uri + '/Banner/{entityId}',
    put: uri + '/Banner/{entityId}',
    putArr: uri + '/Banner/arr',
    delete: uri + '/Banner/{entityId}',

  }, 
  Wrapping: {
    post: uri + '/Wrapping',
    postArr: uri + '/Wrapping/arr',
    get: uri + '/Wrapping',
    getOne: uri + '/Wrapping/{entityId}',
    put: uri + '/Wrapping/{entityId}',
    putArr: uri + '/Wrapping/arr',
    delete: uri + '/Wrapping/{entityId}',

  }, 
  Country: {
    post: uri + '/Country',
    postArr: uri + '/Country/arr',
    get: uri + '/Country/all',
    getOne: uri + '/Country/{entityId}',
    put: uri + '/Country/{entityId}',
    putArr: uri + '/Country/arr',
    delete: uri + '/Country/{entityId}',
  }, City: {
    post: uri + '/City',
    postArr: uri + '/City/arr',
    get: uri + '/City/all',
    getOne: uri + '/City/{entityId}',
    put: uri + '/City/{entityId}',
    putArr: uri + '/City/arr',
    delete: uri + '/City/{entityId}',
  },
  Brand: {
    post: uri + '/Brand',
    postArr: uri + '/Brand/arr',
    get: uri + '/Brand/all',
    getOne: uri + '/Brand/{entityId}',
    put: uri + '/Brand/{entityId}',
    putArr: uri + '/Brand/arr',
    delete: uri + '/Brand/{entityId}',

  },
  Category: {
    post: uri + '/Category',
    postArr: uri + '/Category/arr',
    get: uri + '/Category/all',
    getOne: uri + '/Category/{entityId}',
    put: uri + '/Category/{entityId}',
    putArr: uri + '/Category/arr',
    delete: uri + '/Category/{entityId}',

  },
  Concentration: {
    post: uri + '/Concentration',
    postArr: uri + '/Concentration/arr',
    get: uri + '/Concentration/all',
    getOne: uri + '/Concentration/{entityId}',
    put: uri + '/Concentration/{entityId}',
    putArr: uri + '/Concentration/arr',
    delete: uri + '/Concentration/{entityId}',

  },
  Size: {
    post: uri + '/Size',
    postArr: uri + '/Size/arr',
    get: uri + '/Size/all',
    getOne: uri + '/Size/{entityId}',
    put: uri + '/Size/{entityId}',
    putArr: uri + '/Size/arr',
    delete: uri + '/Size/{entityId}',

  },
  Item: {
    post: uri + '/Item',
    postArr: uri + '/Item/arr',
    get: uri + '/Item/all',
    search: uri + '/Item/search',
    paginated: uri + '/Item/paginated',
    getOne: uri + '/Item/{entityId}',
    put: uri + '/Item/{entityId}',
    putArr: uri + '/Item/arr',
    delete: uri + '/Item/{entityId}',

  }, 
  ItemOption: {
    post: uri + '/ItemOption',
    postArr: uri + '/ItemOption/arr',
    get: uri + '/ItemOption/all',
    getOne: uri + '/ItemOption/{entityId}',
    put: uri + '/ItemOption/{entityId}',
    putArr: uri + '/ItemOption/arr',
    delete: uri + '/ItemOption/{entityId}',

  }, 
  
  OptionValue: {
    post: uri + '/OptionValue',
    postArr: uri + '/OptionValue/arr',
    get: uri + '/OptionValue/all',
    getOne: uri + '/OptionValue/{entityId}',
    put: uri + '/OptionValue/{entityId}',
    putArr: uri + '/OptionValue/arr',
    delete: uri + '/OptionValue/{entityId}',

  }, 
  
  
  StockReceipt: {
    post: uri + '/StockReceipt',
    postArr: uri + '/StockReceipt/arr',
    get: uri + '/StockReceipt/all',
    getOne: uri + '/StockReceipt/{entityId}',
    put: uri + '/StockReceipt/{entityId}',
    putArr: uri + '/StockReceipt/arr',
    delete: uri + '/StockReceipt/{entityId}',

  }, Offer: {
    post: uri + '/Offer',
    postArr: uri + '/Offer/arr',
    get: uri + '/Offer/all',
    getOne: uri + '/Offer/{entityId}',
    put: uri + '/Offer/{entityId}',
    putArr: uri + '/Offer/arr',
    delete: uri + '/Offer/{entityId}',

  },
  PromoCode: {
    post: uri + '/PromoCode',
    postArr: uri + '/PromoCode/arr',
    get: uri + '/PromoCode/all',
    getOne: uri + '/PromoCode/{entityId}',
    put: uri + '/PromoCode/{entityId}',
    putArr: uri + '/PromoCode/arr',
    delete: uri + '/PromoCode/{entityId}',

  },
  WelcomeScreen: {
    post: uri + '/WelcomeScreen',
    postArr: uri + '/WelcomeScreen/arr',
    get: uri + '/WelcomeScreen/all',
    getOne: uri + '/WelcomeScreen/{entityId}',
    put: uri + '/WelcomeScreen/{entityId}',
    putArr: uri + '/WelcomeScreen/arr',
    delete: uri + '/WelcomeScreen/{entityId}',

  },

  TrQty: {
    post: uri + '/TrQty',
    postArr: uri + '/TrQty/arr',
    get: uri + '/TrQty/all',
    getOne: uri + '/TrQty/{entityId}',
    put: uri + '/TrQty/{entityId}',
    putArr: uri + '/TrQty/arr',
    delete: uri + '/TrQty/{entityId}',
  },

  File: {
    upload:  uri+'/File/upload',
    get:  uri+'/File',
    // upload:  'http://server.overrideeg.net:3000/File/upload',
    // upload:  'http://192.168.43.182:3000/File/upload',
    delete: uri + '/File/{entityId}',
  },
  Order: {
    post: uri + '/Order',
    postArr: uri + '/Order/arr',
    get: uri + '/Order/all',
    getOne: uri + '/Order/{entityId}',
    put: uri + '/Order/{entityId}',
    putArr: uri + '/Order/arr',
    delete: uri + '/Order/{entityId}',
    invoice: uri + '/Order/invoice/{entityId}'

  },
  Shipment: {
    post: uri + '/Shipment',
    postArr: uri + '/Shipment/arr',
    get: uri + '/Shipment/all',
    getOne: uri + '/Shipment/{entityId}',
    put: uri + '/Shipment/{entityId}',
    putArr: uri + '/Shipment/arr',
    delete: uri + '/Shipment/{entityId}',

  },
  Invoice: {
    post: uri + '/Invoice',
    postArr: uri + '/Invoice/arr',
    get: uri + '/Invoice/all',
    getOne: uri + '/Invoice/{entityId}',
    put: uri + '/Invoice/{entityId}',
    putArr: uri + '/Invoice/arr',
    delete: uri + '/Invoice/{entityId}',

  },
  supplier: {
    post: uri + '/Supplier',
    postArr: uri + '/Supplier/arr',
    get: uri + '/Supplier/all',
    getOne: uri + '/Supplier/{entityId}',
    put: uri + '/Supplier/{entityId}',
    putArr: uri + '/Supplier/arr',
    delete: uri + '/Supplier/{entityId}',

  },
  PurchaseOrder: {
    post: uri + '/PurchaseOrder',
    postArr: uri + '/PurchaseOrder/arr',
    get: uri + '/PurchaseOrder/all',
    getOne: uri + '/PurchaseOrder/{entityId}',
    put: uri + '/PurchaseOrder/{entityId}',
    putArr: uri + '/PurchaseOrder/arr',
    delete: uri + '/PurchaseOrder/{entityId}',

  },
  Notification: {
    post: uri + '/Notification',
    postArr: uri + '/Notification/arr',
    get: uri + '/Notification/all',
    getOne: uri + '/Notification/{entityId}',
    put: uri + '/Notification/{entityId}',
    putArr: uri + '/Notification/arr',
    delete: uri + '/Notification/{entityId}',

  },
  Report: {

    getOrder: uri + '/Report/OrderChart',
    getProfit: uri + '/Report/ProfitChart',
    getSummary: uri + '/Report/Summary',
    sales: uri + '/Report/Sales',
    getProgressSection: uri + '/Report/ProgressSection',
    getOne: uri + '/Report/{entityId}',
  },
  Review: {
    post: uri + '/Review',
    get: uri + '/Review/all',
    getOne: uri + '/Review/{entityId}',
    put: uri + '/Review/{entityId}',
    delete: uri + '/Review/{entityId}',
  },
  HomeList: {
    post: uri + '/HomeList',
    get: uri + '/HomeList',
    getOne: uri + '/HomeList/{entityId}',
    put: uri + '/HomeList/{entityId}',
    delete: uri + '/HomeList/{entityId}',
  },


};
